const css = `@utility hide-scrollbar{-ms-overflow-style: none;   scrollbar-width: none;  &::-webkit-scrollbar { display: none;   }}`;
export default [css];